export const titleAndDescriptionContainer = `flex flex-col items-center justify-center mt-24px text-center`

export const clockOutActionContainer = `flex items-center px-24px pb-32px gap-x-12px`

export const getClockTitleStyles = (theme: any): string =>
   `text-lg-semibold mt-16px mb-4px ${theme.titleColor}`

export const getClockDescriptionStyles = (theme: any): string =>
   `text-sm-regular ${theme.descriptionColor}`
